<template>
  <div class="footer">
    <div class="kuai" v-for="item in itemList" :key="item.index" @click="tiao(item.id)">
      <img :src="item.itemIcon" alt="" v-show="$route.path !== '/'+item.id ">
      <img :src="item.itemIcon1" alt="" v-show="$route.path == '/'+item.id ">
      <div class="txt">{{item.itemName}}</div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';

export default {
  name: '',
  data () {
    return {
      itemList: [
        {
          itemIcon: '/static/tab/home.png',
          itemIcon1: '/static/tab/home-active.png',
          itemName: '首页',
          id: ''
        },
        {
          itemIcon: '/static/tab/saomiao.png',
          itemIcon1: '/static/tab/saomiao-active.png',
          itemName: '扫一扫',
          id: 'qrcode'
        },
        {
          itemIcon: '/static/tab/orders.png',
          itemIcon1: '/static/tab/orders-active.png',
          itemName: '订单',
          id: 'my'
        }
      ]
    }
  },
  props: {
  },
  methods: {
    // 获取链接字段
    getUrlParam (url, name) {
      var reg = new RegExp('(\\?|&)' + name + '=([^&]+)');
      var r = url.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return false;
    },
    //跳转路由或者唤起扫码
    tiao (data) {
        if (data == 'qrcode') {
          this.goqrcode()
        } else {
          this.$router.push('/'+data)
        }
    },
    //获取config签名 ，扫码开始，第一步
    goqrcode () {
      const vm = this
      const urlStr = location.href.split('#')[0]
      var url = '/getWXSignature'
      this.$axios({
        method: 'post',
        url: url,
        data: JSON.stringify({
          'url': encodeURI(urlStr)
        }),
      }).then((response) =>{
          console.log(response)
          let appId = response.data.appid
          let timeStamp = response.data.timeStamp
          let nonceStr = response.data.nonceStr
          let signature = response.data.signature
          this.qrcode(appId,timeStamp,nonceStr,signature)
      }).catch((error) =>{
          console.log(error)
      })
    },

    // 调起config 扫码第二步
    qrcode (appId,timeStamp,nonceStr,signature) {    //调起微信扫码
    const vm = this
      wx.config({
        debug: false,
        appId: appId,//后台获取
        timestamp: timeStamp,//后台获取
        nonceStr: nonceStr,//后台获取
        signature: signature,//后台获取
        jsApiList : [// 所有要调用的 API 都要加到这个列表中
          'scanQRCode'
        ],
      });
      wx.ready(function(){
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            let chapterId = vm.getUrlParam(result,'id')
            let type = vm.getUrlParam(result,'type')
            if (!chapterId) {
              alert('二维码章节不存在')
            } else {
              vm.$router.push({
                path: '/bookabout',
                query: {
                  chapterId : chapterId
                }
              })
            }
          }
        });
      });
      wx.error(function(res){
        console.log(res)
      });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  background-color: rgb(255, 255, 255);
  color: rgb(105, 105, 105);
  font-size: .24rem;
  border-top: 1px solid rgb(143, 143, 143);
  height: 1rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  align-items: flex-end;
}

.kuai {
  position: relative;
  text-align: center;
}

img {
  width: .5rem;
  height: .5rem;
}

.active {
  position: absolute;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue